import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spin, Table } from 'antd';
import { Query } from 'react-apollo';
import Link from '../components/general/Link';

import QUERY from '../graphql/queries/allRetainerClientsQuery.graphql';

const { Column } = Table;

const AllClientsPage = ({ match }) => (
  <div className="contentBox">
    <h1>All Clients</h1>
    <div>
      <Link to={`${match.url}/create`}>
        <Button type="primary">Add new client</Button>
      </Link>
    </div>
    <Query query={QUERY}>
      {({ loading, error, data }) => {
        if (loading) return <Spin size="large" />;
        if (error) return `Error! ${error.message}`;

        const { allRetainerClients } = data;
        return (
          <Table dataSource={allRetainerClients} rowKey="id">
            <Column
              title="Company Name"
              dataIndex="name"
              key="name"
              render={(text, record) => <Link to={`${match.url}/${record.id}`}>{text}</Link>}
            />
            <Column title="Login Username" dataIndex="username" key="username" />
            <Column title="Start Date" dataIndex="startDate" key="startDate" />
            <Column title="Constitution" dataIndex="constitution" key="constitution" />
            <Column
              title="Contact Details"
              key="contactDetails"
              render={(text, record) => (
                <div>
                  <p>
                    {record.address.streetAddress}, {record.address.city} - {record.address.pincode}
                  </p>
                  <p>
                    <strong>Email: </strong>
                    {record.email}
                  </p>
                  <p>
                    <strong>Landline: </strong>
                    {record.landline}
                  </p>
                </div>
              )}
            />
            <Column
              title="Primary Contact"
              key="primaryContact"
              render={(text, record) => (
                <div>
                  <p>
                    <strong>Name: </strong>
                    {record.primaryContact.name}
                  </p>
                  <p>
                    <strong>Designation: </strong>
                    {record.primaryContact.designation}
                  </p>
                  <p>
                    <strong>Mobile: </strong>
                    {record.primaryContact.mobile}
                  </p>
                  <p>
                    <strong>Email: </strong>
                    {record.primaryContact.email}
                  </p>
                </div>
              )}
            />
            <Column
              title="Other contacts"
              key="contacts"
              render={(text, record) => {
                if (Array.isArray(record.contacts) && record.contacts.length > 0) {
                  return (
                    <div>
                      {record.contacts.map((entry) => (
                        <p>
                          <strong>Name: </strong>
                          {entry.name}
                          <br />
                          <strong>Mobile: </strong>
                          {entry.mobile}
                          <br />
                          <strong>Email: </strong>
                          {entry.email}
                        </p>
                      ))}
                    </div>
                  );
                }
                return <p>No additional contact.</p>;
              }}
            />
          </Table>
        );
      }}
    </Query>
  </div>
);

AllClientsPage.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default AllClientsPage;



// WEBPACK FOOTER //
// ./src/pages/AllClientsPage.jsx